import { z } from "zod";

export const spotIncentiveSchema = z.object({
  name: z.string().min(1, "Name is required"),
  taskId: z.number().nullable().refine((val) => val !== null, {
    message: "Please select a task",
  }),
  resourceIds: z.array(z.number()).min(1, "Select at least one resource"),
  startDate: z.string(),
  endDate: z.string(),
  positiveTagIds: z.array(z.number()).default([]),
  negativeTagIds: z.array(z.number()).default([]),
  multiplyByDays: z.boolean().default(false),
  fileId: z.number().nullable().optional(),
  uploadedDocumentId: z.number().nullable().optional(),
  uploadedFileName: z.string().optional(),
}).refine(
  (data) => data.positiveTagIds.length > 0 || data.negativeTagIds.length > 0,
  {
    message: "Please assign at least one positive or negative tag to adjust points",
    path: ["positiveTagIds"],
  },
);

export type SpotIncentiveFormData = z.infer<typeof spotIncentiveSchema>;
